import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive';

import { ModalManagerContext } from '../../ModalsManager';
import GenderBarEchart from '../../common/charts/GenderBarChart';
import useFetch from '../../../utils/useFetch';
import PlotWrapper from '../../common/PlotWrapper';

import useStyles from './styles';
import GenderPieEchart from '../../common/charts/GenderPieChart';
import { parseBarEtarianStats, parsePieEtarianStats } from './utils';


const url = (placementId) => `${process.env.REACT_APP_API_URL}/analytics/demographics/${placementId}`;

const DemographicsProfile = ({ state }) => {
  const { t } = useTranslation(['translation']);
  const openModal = useContext(ModalManagerContext);
  const { render } = useFetch(url(state.placementSelected), openModal);
  const isMobile = useMediaQuery({ maxWidth: 900 });

  const classes = useStyles();
  return render(data => (
    <div className={classes.demographicsContainer}>
      <PlotWrapper
        title={t('ANALYTICS.DEMOGRAPHICS_TITLE')}
        overriddenClasses={{ plotWrapper: classes.plotWrapper }}
        showTooltip
        tooltipText={t('ANALYTICS.DEFAULT_TOOLTIP_TEXT')}
      >
        <GenderBarEchart
          title={t('ANALYTICS.DEMOGRAPHICS_CLIENTS')}
          data={parseBarEtarianStats(data.etarian_stats)}
        />
      </PlotWrapper>
      <PlotWrapper
        title={isMobile ? '' : ' '}
        overriddenClasses={{ plotWrapper: classes.plotWrapper }}
      >
        <GenderPieEchart
          title={t('ANALYTICS.GENDER_COMPARISON')}
          data={parsePieEtarianStats(data.etarian_stats)}
          unitName={t('ANALYTICS.GENDER_COMPARISON_UNIT')}
        />
      </PlotWrapper>
    </div>
  ));
};


export default DemographicsProfile;
